/**
 * 右上角分享组件（custom-share、picture-share）相关
 */
import ClipboardJS from 'clipboard'
import URL from '@/http/url'
import axios from '@/http/http'
import UplusApi from '@uplus/uplus-api'
const instance = new UplusApi()
instance.initDeviceReady()

export default {
  data() {
    return {
      loadShareModal: false,
      showShareModal: false,
      loadPictureShare: false,
      showPictureShare: false,
    }
  },
  methods: {
    openShareModal() {
      this.loadShareModal = true
      this.showShareModal = true
      this.$nextTick(()=>{
        this.$refs.shareSheet.open()
      })
    },
    copyLink() {
      let url = this.shareLinkFactory('CopyLink')
      const a = document.createElement('a')
      if (this.$util.isSyBird() && url.indexOf('open_source') === -1) {
        url = this.$util.checkUrladdString(url, 'open_source=haier-sybird-h5')
      }
      const clipboard = new ClipboardJS(a, {
        text: function (trigger) {
          return url
        },
      })
      clipboard.on('success', () => {
        this.$toast('复制链接成功')
      })
      clipboard.on('error', () => {
        this.$toast('复制链接失败')
      })
      a.click()
      if (this.$util.isSyBirdOrShopKeeper()) {
        let eventId = 'BD20122'
        if (this.$util.isShopKeeper()) {
          eventId = 'YG20100'
        }
        const gioParams = {
          third_platform: '复制链接',
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
        }
        this.$util.gioTrackWithVariable(eventId, gioParams, true)
      }
    },
    // 智家默认分享
    defaultShareFn(params = {}) {
      this.gioBD20114()
      this.gioHZ20017()
      this.enterTime = Date.now()

      this.$util.gioTrackWithVariable('MB13409', {
        user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
        member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
        productId_var: this.productId + '',
      })
      // let url = this.mId
      //   ? `${location.origin}${location.pathname}?productId=${this.productId}&storeId=${this.mId}&shareId=${this.mId}`
      //   : `${location.origin}${location.pathname}?productId=${this.productId}`
      // if (this.storeInfo && this.storeInfo.mdCode) url += `&mdCode=${this.storeInfo.mdCode}`

      //         linkUtil.openLink('/pages/product/detail/index', queryParam)
      let url = this.shareLinkFactory(params.platformType)
      let thumbImg = this.getShareImage()
      console.log('thumbImg==>', thumbImg)
      if (this.$util.isSyBird() && params.platformType === 'WechatSession') {
        // 三翼鸟环境 拼接小程序路径
        let param = url.split('?')[1]
        url = '/subPages/product/detail/index?' + param
      } else if (this.$util.isShopKeeper() && params.platformType === 'WechatSession') {
        let param = url.split('?')[1]
        url = '/pages/product/detail/index?' + param
      } else if(this.$util.isUplus() && params.platformType === 'WechatSession') {
        let param = url.split('?')[1]
        url = '/subPages/product/detail/index?' + param
      }
      if (this.$util.isSyBirdOrShopKeeper()) {
        let eventId = 'BD20122'
        if (this.$util.isShopKeeper()) {
          eventId = 'YG20100'
        }
        const gioParams = {
          third_platform: 'null',
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
        }
        switch (params?.platformType) {
          case 'Sina':
            gioParams.third_platform = '微博'
            break
          case 'QQzone':
            gioParams.third_platform = 'QQ空间'
            break
          case 'WechatTimeLine':
            gioParams.third_platform = '朋友圈'
            break
          case 'QQ':
            gioParams.third_platform = 'QQ'
            break
          case 'WechatSession':
            gioParams.third_platform = '微信'
            break
        }
        this.$util.gioTrackWithVariable(eventId, gioParams, true)
      }
      let shareParams = {
        title: this.products.productFullName,
        desc: this.products.productTitle,
        url, // 不传默认当前url
        thumImage:  thumbImg?.startsWith('https://') ? thumbImg : thumbImg?.replace('http', 'https'), // 取轮播图第一张
        shareType: this.$util.isHaierApp() && params.platformType === 'WechatSession' ? 'uni' :  this.$util.isUplusOrShopKeeper() && params.platformType === 'WechatTimeLine' ? 'image' : '',
        ...params,
      }
      if(this.$util.isUplusOrShopKeeper() && params.platformType === 'WechatTimeLine'){
        shareParams.image = shareParams.thumImage = sessionStorage.getItem('sg_wxtlsharepic')
      }

      this.$util
        .inAppShare(shareParams)
        .then((res) => console.log(res))
        .catch((e) => {
          console.log(e)
        })
      this.afterShare()
    },
    /**
     * 从this.swiperImgs中取到图片url
     * @returns
     */
    getShareImage() {
      return this.swiperImgs.find((v) => typeof v === 'string')
    },
    /**
     * @description 分享完成后执行操作
     */
    afterShare() {
      let _this = this
      if (this.$util.isHaierApp()) {
        this.$util.smMsgSdk()
        if (this.$store.state.isShareTask) {
          instance
            .initDeviceReady()
            .then(() => {
              instance.upAppinfoModule
                .getAppInfo()
                .then((info) => {
                  let deviceInfo = info.retData
                  if (deviceInfo.appKey) {
                    this.$util
                      .dealSmDeviceId()
                      .then((deviceId) => {
                        axios
                          .post(URL.getNotifyTaskFinished, {
                            accountToken: this.$store.state.sdToken,
                            clientId: deviceInfo.clientId,
                            appVersion: deviceInfo.appVersion,
                            appKey: deviceInfo.appKey,
                            appId: deviceInfo.appId,
                            accessToken: this.$store.state.sdToken,
                            taskCode: 'TASK1042',
                            deviceId: deviceId,
                            userId: localStorage.getItem('ucId'),
                            taskSource: 'VIP_CENTER',
                          })
                          .then(() => {
                            _this.$store.commit('setIsShareTask', false)
                            this.$reviewTimetoast({ type: 2, productId: this.$route.query.productId })
                          })
                          .catch((e) => {
                            console.log(e)
                          })
                      })
                      .catch(() => {})
                  }
                })
                .catch((e) => {
                  console.log(e)
                })
            })
            .catch((e) => {
              console.log(e)
            })
        }
      }
    },
    openPictureShare() {
      this.loadPictureShare = true
      this.showPictureShare = true
      if (this.$util.isSyBirdOrShopKeeper()) {
        let eventId = 'BD20122'
        if (this.$util.isShopKeeper()) {
          eventId = 'YG20100'
        }
        const gioParams = {
          third_platform: '画报分享',
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
        }
        this.$util.gioTrackWithVariable(eventId, gioParams, true)
      }
    },
    shareLinkFactory(sharePlatform) {
      let url = `${location.origin}${location.pathname}`
      const query = {
        ...this.getCleanQuerys(),
        productId: this.productId,
      }
      if (this.getCurrentRole?.userIdentity) query.shareRole = this.getCurrentRole.userIdentity
      if (this.mId) {
        // query.storeId = this.mId
        query.shareId = this.mId
      }
      query.linkType = 'share'
      query.sharePlatform = sharePlatform
      query.uid = localStorage.getItem('ucId')
      if (this.$util.isSyBird()) {
        query.open_source = 'haier-sybird-h5'
      }
      if (this.$util.isShopKeeper()) {
        query.downloadAppType = 0 // 从工作台分享出去的不展示下载app提示
        query.open_source = 'haier-app-shopKeeper-shared'
      }
      if (this.$util.isUplus()) {
        query.open_source = 'haier-app-zj-shared'
      }

      this.visitStoreHandler(query)
      const queryString = this.$util.parseParamsToQuery(query)
      return url + queryString
    },
  },
}
